<template>
  <div class="wrapper">

    <side-bar>
      <template slot="links">
        <sidebar-item class="d-block d-lg-none"
          :link="{
            name: $t('admin.menu.home'),
            path: '/',
            icon: './img/icons/common/home-solid.svg'
          }">
        </sidebar-item>
        <sidebar-item v-if="isAdmin"
          :link="{
            name: $t('admin.menu.listcarousels'),
            path: '/blogs',
            icon: './img/icons/common/list-ul-solid.svg'
          }">
        </sidebar-item>
        <sidebar-item v-if="isAdminServiceLines"
          :link="{
            name: $t('admin.menu.meetup'),
            path: '/admin/meetup',
            icon: './img/icons/common/sl.svg'
          }">
        </sidebar-item>
        <sidebar-item
          :link="{
            name: $t('admin.menu.users'),
            path: '/users',
            icon: './img/icons/common/users-cog-solid.svg'
          }">
        </sidebar-item>

        <b-navbar-nav  class="mobile-admin-nav align-items-lg-center ml-lg-auto d-block d-lg-none">
          <b-nav-item>
              <span class="nav-link-inner--text" @click="setLanguage('fr')" :class="[language == 'fr'? 'language active':'language']">{{ $t('language.fr') }}</span>
              |
              <span class="nav-link-inner--text" @click="setLanguage('en')" :class="[language == 'en'? 'language active':'language']">{{ $t('language.en') }}</span>
              |
              <span class="nav-link-inner--text" @click="setLanguage('pl')" :class="[language == 'pl'? 'language active':'language']">{{ $t('language.pl') }}</span>
          </b-nav-item>          
        </b-navbar-nav> 
        
      </template>
      <div class="copyright d-none d-lg-block">
        <span class="">© {{ year }} | {{ $t('generic.stename') }}</span>
      </div>
    </side-bar>
    <div class="main-content">
      <admin-navbar></admin-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>

    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import AdminNavbar from './AdminNavbar.vue';
  import AdminContent from './AdminContent.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      AdminNavbar,
      AdminContent,
      FadeTransition
    },
    data() {
      let user = this.$store.getters.User;
      return {
        isAdmin: user.usr_admin,
        isAdminServiceLines: user.usr_adminservicelines,
        language: Vue.i18n.locale(),
        year: new Date().getFullYear()
      };
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
      setLanguage (locale) {
        Vue.i18n.set(locale);
        this.language = locale;
        localStorage.setItem(Vue.Keys.LANGUAGE, locale);
        this.$router.go();
      }      
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
</style>
